import { useMemo, useContext } from 'react';
import Button from "../button";
import Radio, { RadioGroup, RadioGroupWithOther } from "../radio";
import Input, { PhoneNumber, Amount, Email, Password, InputNumber, TextArea, InputDate, CreditCard, Otp, ExpiryDate, InputId } from "../input";
import DatePicker, { IglooBuddhistDatePicker as BuddhistDatePicker, IglooRangePicker as RangePicker, IglooWeekPicker as WeekPicker, IglooMonthPicker as MonthPicker } from "../date-picker";
import Confirmation from "../confirmation";
import { AttachedSelect as Select, TimeSelect } from "../select";
import Checkbox, { CheckboxGroup } from "../checkbox";
import Upload from "../upload";
import Declaration from "../declaration";
import Divider from "./divider";
import UploadPhoto from "../upload-photo";
import RenderElement from "./render";
import Typography from "../typography";
import SearchBox from "../search-box";
import formContext from "../form-context";
import OCR from "../ocr";
var elementMap = {
  Input: Input,
  PhoneNumber: PhoneNumber,
  Amount: Amount,
  InputNumber: InputNumber,
  InputId: InputId,
  TextArea: TextArea,
  DatePicker: DatePicker,
  CreditCard: CreditCard,
  Otp: Otp,
  BuddhistDatePicker: BuddhistDatePicker,
  WeekPicker: WeekPicker,
  MonthPicker: MonthPicker,
  RangePicker: RangePicker,
  Radio: Radio,
  RadioGroup: RadioGroup,
  RadioGroupWithOther: RadioGroupWithOther,
  Button: Button,
  Select: Select,
  TimeSelect: TimeSelect,
  Email: Email,
  Checkbox: Checkbox,
  CheckboxGroup: CheckboxGroup,
  Upload: Upload,
  Declaration: Declaration,
  Password: Password,
  Divider: Divider,
  UploadPhoto: UploadPhoto,
  InputDate: InputDate,
  Confirmation: Confirmation,
  ExpiryDate: ExpiryDate,
  Typography: Typography,
  SearchBox: SearchBox,
  OCR: OCR
};
var Unknown = function Unknown() {
  return 'Unknown Form Item';
};
var useComponent = function useComponent(config) {
  var _useContext = useContext(formContext),
    _useContext$customize = _useContext.customizeComponents,
    customizeComponents = _useContext$customize === void 0 ? {} : _useContext$customize;
  var type = config.type,
    render = config.render;
  if (!type && !render) {
    return {
      Component: Unknown,
      formItemProps: {},
      withoutForm: false
    };
  }
  return useMemo(function () {
    var Component = type ? elementMap[type] || customizeComponents[type] || Unknown : RenderElement;
    var formItemProps = typeof Component.formItemPropsHandler === 'function' ? Component.formItemPropsHandler(config) : {};
    return {
      Component: Component,
      formItemProps: formItemProps,
      withoutForm: type === 'Divider' || Boolean(config.withoutForm) || config.name === undefined
    };
  }, [config.type]);
};
export default useComponent;